<template>
	<div id="ContainerGroupNotes">
		<div class="row">
			<div class="col-12">
			<MdTitle v-bind:Text="$t('Shared.GroupNotes')" />  
			<div class="flex-container">
				<b-row>
					<b-col md="4" lg="4" sm="12">
						<!--<MdEdit 
							v-bind:Label="$t('Shared.datefrom')"
							v-bind:TypeProp="'date'" 
							v-bind:Name="'DateFrom'"
							v-model="DateFrom"
							v-bind:Min="'1900-01-01'"
							v-bind:Max="'2200-12-31'"
							v-bind:isValid="this.isDateFromValid"
							v-bind:isRequired="true"
							v-on:change="DateFromChange($event)"
							v-bind:OnPressEnter="Search"           
						>                                     
						</MdEdit>-->
						<MdDateTime 
							:Label="$t('Shared.datefrom')" 
							:Model="DateFrom"                           
							@input="DateFrom = $event"                            
							:Id="'GroupNotesListDateFrom'"
							:Type="'date'"                  
							:isRequired="true" 
							:Change="DateFromChange" 
							:OnPressEnter="Search"                         
							:isConfirm="false"
							:ReadOnly="false"
							:isValid="isDateFromValid">
						</MdDateTime>
					</b-col>
					<b-col md="4" lg="4" sm="12">
						<!--<MdEdit 
							v-bind:Label="$t('Shared.dateTo')"
							v-bind:TypeProp="'date'" 
							v-bind:Name="'DateTo'"
							v-model="DateTo"
							v-bind:Min="'1900-01-01'"
							v-bind:Max="'2200-12-31'"
							v-on:change="DateToChange($event)"          
							v-bind:isValid="this.isDateToValid"
							v-bind:OnPressEnter="Search">                                     
						</MdEdit>-->
						<MdDateTime 
							:Label="$t('Shared.dateTo')" 
							:Model="DateTo"                           
							@input="DateTo = $event"                            
							:Id="'GroupNotesListDateTo'"
							:Type="'date'"                  
							:isRequired="true" 
							:Change="DateToChange" 
							:OnPressEnter="Search"                         
							:isConfirm="false"
							:ReadOnly="false"
							:isValid="isDateToValid">
						</MdDateTime>
					</b-col>
					<b-col md="4" lg="4" sm="12">									
						<MdSelect
							v-bind:Label="$tc('Shared.Program',2)"
							v-bind:Options="ProgramList"
							v-bind:Model="ProgramVmodel"
							v-bind:FieldDescription="'name'"
							v-bind:FieldCode="'code'"
							v-bind:Placeholder="selectPlaceholder"
							v-bind:Multiple="false"
							v-bind:isRequired="true" 
							v-bind:FeedBackText="$t('GroupNotes.fBakProCodeMsg')"     
							v-bind:RequireEvent="true"
							v-bind:isValid="isProgramCodeValid"
							v-bind:IfUsevalidation="false"
							:Input="ChangeDropDownPrograms"
							v-bind:AllowEmpty="false"/>
					</b-col>
				</b-row>	
				<b-row>
					<b-col md="4" lg="4" sm="12">								
					<div class="form-group">
						<MdSelect
							v-bind:Label="$t('Shared.Therapies')"
							v-bind:Options="TherapyList"
							v-bind:Model="TherapyVModel"
							v-bind:Placeholder="selectPlaceholder"																
							v-bind:FieldDescription="'name'"
							v-bind:Multiple="false"
							v-bind:isRequired="true"
							v-bind:RequireEvent="true" 
							v-bind:Tag="'GroupNotesFilterTherapies'"
							v-bind:isValid="isTherapyCodeValid"
							v-bind:FeedBackText="$t('GroupNotes.fBakTheCodeMsg')"  
							v-bind:FieldCode="'code'"
							:Input="ChangeDropDownTherapies"
							v-bind:Name="'therapies_select'"
							id="therapies_select"
							v-bind:AllowEmpty="false"/>
					</div>		
					</b-col>
					<b-col md="4" lg="4" sm="12">													
					<div class="form-group">
						<MdSelect
							v-bind:Label="$tc('Shared.Note', 2)"
							v-bind:FieldDescription="'description'"
							v-bind:FieldCode="'notesID'"
							v-bind:Options="NotesList"
							v-bind:ModelArray="NotesVmodel"
							v-bind:Placeholder="selectPlaceholder"
							v-bind:Multiple="false"
							v-bind:RequireEvent="true" 
							v-bind:Tag="'GroupNotesFilterNotes'"
							v-bind:isRequired="true" 						
							v-bind:isValid="isNoteValid"
							v-bind:FeedBackText="$t('GroupNotes.fBakNoteMsg')"  
							:Input="ChangeDropDownNotes"
							v-bind:Name="'note_notes_select'"
							id="note_notes_select"
							v-bind:AllowEmpty="false"/>
					</div>									
					</b-col>
					<b-col md="4" lg="4" sm="12">
						<MdSelect
						v-bind:Label="$tc('Shared.Therapist')"
						v-bind:FieldDescription="'name'"
						v-bind:FieldCode="'code'"
						v-bind:Options="TherapistList"
						v-bind:Model="TherapistVModel"
						v-bind:Placeholder="selectPlaceholder"
						v-bind:Multiple="false"
						:Input="ChangeDropDownTherapist"/>
					</b-col>																		
				</b-row>	
				<b-row>
					<b-col md="4" lg="4" sm="12">													
					<div class="form-group">
						<MdSelect
							v-bind:Label="$t('Shared.Status')"
							v-bind:Options="OptionNoteStatus"
							v-bind:ModelArray="NoteStatusVModel"
							v-bind:Placeholder="selectPlaceholder"																
							v-bind:FieldDescription="'name'"
							v-bind:Multiple="false"
							v-bind:FieldCode="'value'"
							v-bind:IfUsevalidation="false"
							:Input="ChangeDropDownNoteStatus"
							v-bind:Name="'note_status_select'"
							id="note_status_select"/>
					</div>										
					</b-col>
					<b-col md="12">
						<div class="text-center text-md-right mt-3">
							<button 
								v-on:click="Search"
								type="button"
								class="btn btn-primary btn-login mx-2 pull-right"												
								id="btnsearchinputpending">
								{{$t('Shared.Search')}}								
							</button>							
						</div>
					</b-col>
				</b-row>		
			</div>				
	</div>
</div>
		<div class="row">
			<div class="col-12">
				<div class="mt-4">
					<MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
					<div class="row">
						<div class="col-md-12">
							<div>
							<MdTable
								v-bind:fields="fields"
								v-bind:items="items"
								v-bind:totalRows="totalRows"
								v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
								v-bind:currentPage="currentPage"
								v-bind:perPage="perPage"
								v-bind:pageOptions="pageOptions"
								v-bind:refTable="refTable"
								v-bind:FieldsDate="FieldsDateArr"
								v-bind:IsGroupNotes="true"
								:viewIconEvent="ViewIconFunc"
								:onRowSelected="onRowSelected"
								:onFiltered="onFiltered"
								:pageChanged="pageChanged"
								:perPageFunction="PerPageFunction">
							</MdTable>
						</div>  
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
  
  <script>
  
import EnumService from "@/services/enum.service";
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import EmployeeService from '@/services/employee.service'
import ProgramService from '@/services/programs.services'
import GroupNotesService from '@/services/groupnotes.service'
import TherapyService from '@/services/therapy.service'
import GlobalService from '@/services/global.service'
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'

export default {
	mixins: [ShowMessage, DBFunctions,Permission],
	name: 'GroupNotes',
	components: {
		
	},
	data() {
		return { 
			ProgramList:[],
			TherapistList:[],
			TherapyList: [],
			aGroupCreationID:"",
			DateList:[],
			NotesList:[],
			isProgramCodeValid:true,
			isTherapyCodeValid:true,			
			isNoteValid:true,
			ProgramVmodel:{code:"",name:""},
			NotesVmodel: {notesID:"",description:""},
			DateFrom: Utils.formatterDate(Date(), "LLLL"),
			DateTo: Utils.formatterDate(Date(), "LLLL"),
			isDateFromValid: true,
			isDateToValid: true,
			TherapistVModel:{code:"",name:this.$t('Shared.All')},
			TherapyVModel: {code:"",name:""},
			StartDate:null,
			ProgramSelected:"",
			ProgramSelectedList:[],
			selectPlaceholder: this.$t('MdSelect.sOption'),
			NoteStatusVModel: {value:'',name: this.$t('Shared.All')},
			pageOptions: [5, 10, 15],			
			totalRows: 0,		
			currentPage: 1,		
			perPage: 10,			
			filter: null,
			filterOn: [],
			refTable: "selectableTable",
			NotesId:'',
			OptionsRightMenu:{
			btnGroupNotesvisible:false,
			visible:false,
			ItemsList:[],
			btnvisible:false,
			itemdisabled: false,		
			PatientCode:''			
			},
			OptionNoteStatus: EnumService.StatusGroupNotes,
			items: [],
			ShowMessageIsEmpty: false,
			fields: [
				{ key: 'transDate', label: this.$t('Shared.NoteDate'), sortable: true},	
				{ key: 'transDateGroupNotes', label: this.$t('Shared.NoteDate'), sortable: true,class:'hidden'},	
				{ key: 'therapistName', label: this.$tc('Shared.Therapist',1), sortable: true},	
				{ key: 'groupCreationID', label: this.$t('GroupNotes.groupCreId'), sortable: true,class:'hidden'},					
				{ key: 'status', label: this.$t('Shared.Status'), sortable: true,class:'hidden'},
				{ key: 'statusGroupNotes', label: this.$t('Shared.Status'), sortable: true,class:'hidden'},
				{ key: 'billedStatus', label:  this.$t('Shared.Billable'), sortable: true},
				
					
			],
			FieldsDateArr:['transDate'],

		}
	},
  
computed: {
		
},

methods: { 

	async SaveFilters(groupCreationID, noteId, transDate, status, programCode, therapistCode, therapyCode, noteName) {
		await this.$store.commit('setGroupNotesFilters',[]);
		var filters = {
			GroupCreationId: groupCreationID,
			NoteName: noteName,
			TransDate: Utils.formatterDate(transDate, Utils.getShortDateFormat()),
			ProgramCode: programCode,
			TherapistCode: therapistCode,
			TherapyCode: therapyCode,
			NoteId: noteId,
			Status: status,
		}
        
		await this.$store.commit('setGroupNotesFilters',filters);
	},

	async ViewIconFunc(row){
		await this.SaveFilters(row.groupCreationID, row.noteId,row.transDate,row.status, row.programCode, 
								row.therapistCode, row.therapyCode, row.noteName);	
        this.$router.push({ name: "groupnotes-Dashboard",params: { id: row.groupCreationID }});
	},

	getTwoRandom(min, max) {
		return Math.round(Math.random() * (max - min) + min);  
	},

	GetTimedKey(){
		return ""+new Date().getTime()+this.getTwoRandom(10,99);
	},

	validate_required() {       
        this.isProgramCodeValid =  this.ProgramVmodel && this.ProgramVmodel.code &&  this.ProgramVmodel.code.length > 0 ? true : false;  
		this.isTherapyCodeValid = this.TherapyVModel && this.TherapyVModel.code && this.TherapyVModel.code.length > 0 ? true : false;
		this.isNoteValid = this.NotesVmodel && this.NotesVmodel.notesID && this.NotesVmodel.notesID.length > 0  ? true : false;
		this.isDateFromValid = this.DateFrom === null || this.DateFrom === '' ? false : true
		this.isDateToValid = this.DateTo === null || this.DateTo === '' ? false : true

        return this.isProgramCodeValid && this.isTherapyCodeValid && this.isNoteValid && this.isDateFromValid && this.isDateToValid;
    },

	Search(){
		this.currentPage = 1;
		if(this.validate_required()){
			this.currentPage = 1;
			this.getDates();	
		}else{
			this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
		}
	},

	ChangeDropDownPrograms(programs){		
		this.ProgramVmodel = programs;
		this.currentPage = 1;
		this.ProgramSelected = programs.code;		

		if(this.ProgramSelected !== ""){			
			this.getTherapyGroupNotes();		
			this.TherapyVModel = {code:"",name:""};
			this.NotesVmodel = {notesID:"",description:""};
			EventBus.$emit('ChangedDrop', {model:this.TherapyVModel,Tag:"GroupNotesFilterTherapies"});
			EventBus.$emit('ChangedDrop', {model:this.NotesVmodel,Tag:"GroupNotesFilterNotes"});			
			this.isProgramCodeValid = true
			this.items = []
		}else{
			this.TherapyList = [];
			this.TherapyVModel = "";
		}		
	},

	ChangeDropDownTherapist(therapist){
		this.TherapistVModel = therapist ? therapist: "";
		this.currentPage = 1;
	},

	ChangeDropDownNoteStatus(NoteStatus){
		this.NoteStatusVModel = NoteStatus ? NoteStatus: "";
		this.currentPage = 1;
	},

	async ChangeDropDownTherapies(value){		
		this.TherapyVModel = value ? value : "";
		this.currentPage = 1;
		this.NotesList = [];	
		//this.ResetNotes = true;		
		this.NotesVmodel = {notesID:"",description:""};
		//EventBus.$emit('OnResetModelSelect'); 
		//this.ResetNotes = false;	
		var therapy = null;
		this.items = []
		if(typeof this.TherapyVModel === 'object'){
			therapy = this.TherapyVModel.code;
			this.isTherapyCodeValid = true
		}
		await this.getNotes(this.ProgramSelected,therapy);
		if (this.NotesList.length > 0) {
			this.NotesVmodel = this.NotesList[0]
			this.isNoteValid = true
		}
	},

	ChangeDropDownNotes(note){	
		this.NotesVmodel = note ? note : {};
		this.currentPage = 1;
		this.items = []
	},

	DateFromChange() {	
		this.currentPage = 1;
    },

    DateToChange() {	
		this.currentPage = 1;
    },

	onRowSelected(){

	},

	onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

	pageChanged (page) {            
		this.currentPage = page;
		this.getDates();
	},

	PerPageFunction(perpage){
		this.perPage = perpage;    
		this.currentPage = 1;
		this.getDates();
    },

	async getProgramsGroupNotes(){
		await ProgramService.getProgramsGroupNotes()
			.then((response) => {
				if(response.data && response.data.length > 0){
					this.ProgramList = response.data;					
					if(this.ProgramList.length === 1){						
						this.ProgramVmodel.code = this.ProgramList[0].code; 
						this.ProgramVmodel.name = this.ProgramList[0].name; 
						this.ProgramSelected = this.ProgramList[0].code;
						this.getTherapyGroupNotes();
					}

				}             
			})
			.catch((error) => {				
                this.showResponseErrorMessage(error);
			});
	},

	async getEmployeeGroupNotes(){
		await EmployeeService.getEmployeeGroupNotes()
			.then((response) => {
				if(response.data && response.data.length > 0){
				this.TherapistList = response.data;	
				this.TherapistList.unshift({code:"",name:this.$t('Shared.All')});	
				}             
			})
			.catch((error) => {				
                this.showResponseErrorMessage(error);
			});
	},

	getTherapyGroupNotes(){				
		TherapyService.getTherapyGroupNotes(this.ProgramSelected)
			.then((response) => {
				if(response.data && response.data.length > 0){
					this.TherapyList = response.data;					
				}  				       
			})
			.catch((error) => {				
                this.showResponseErrorMessage(error);
			});
	},


	async getNotes(program,therapy){		
		this.NotesList = [];		
		await GroupNotesService.getNotes(program,therapy)
			.then((response) => {
				if(response.data && response.data.length > 0){
					this.NotesList = response.data;	
				} 				  
			})
			.catch((error) => {				
                this.showResponseErrorMessage(error);
			});
	},

	PrepareCallDate(){
		var data = {};
		data.TherapyCode = typeof this.TherapyVModel === 'object' ? this.TherapyVModel.code.trim() : ""; 
		data.NoteID = typeof this.NotesVmodel === 'object' ? this.NotesVmodel.notesID.trim() : ""; 
		data.NoteStatus = typeof this.NoteStatusVModel === 'object' ? this.NoteStatusVModel.value : ""; 
		data.TherapistCode = typeof this.TherapistVModel === 'object' ? this.TherapistVModel.code.trim() : ""; 	
		data.DateFrom = this.DateFrom
		data.DateTo = this.DateTo
		return data;
	},

	getDates(){		
		var param = this.PrepareCallDate();
		param.ProgramCode = this.ProgramSelected; 
		param.PatientCode = null;
		param.PageNumber = this.currentPage;
        param.PageSize = this.perPage;
		GroupNotesService.getDates(param)
			.then((response) => {
				if(response.data){
					this.items = response.data;
					
					let headerString = response.headers["x-pagination"];
					this.Header = JSON.parse(headerString);
					this.totalRows = this.Header.TotalCount;
					
					var noteName = this.NotesVmodel.description;
					this.items.forEach(element => {
						if(element.transDate){
							element.transDate = Utils.formatterDateToString(element.transDate); //moment(element.transDate).format("ddd, ll");
							element.transDateGroupNotes = Utils.formatterDateToString(element.transDate);
						}
						element.statusGroupNotes = element.status;
					element.therapyName = noteName;
					})
				} 
				this.ShowMessageIsEmpty = response.data.length > 0 ? false : true				
				
			})
			.catch((error) => {				
                this.showResponseErrorMessage(error);
			});
	},

	async getDateTime() { 
        await GlobalService.getDateTime()
            .then((response) => {      
				if (response.data) {
					this.StartDate = Utils.formatterDate(response.data);
				}  
			})
			.catch(error => {				
                this.showResponseErrorMessage(error);   
			}); 
    },

	async ExecuteAllCalls(){
		await this.getDateTime()
		await this.getProgramsGroupNotes();
		await this.getEmployeeGroupNotes();	
	},
},
  
    async mounted() {       
		await Promise.all([await this.ExecuteAllCalls()]);

		this.OptionsRightMenu.ItemsList = [];
		let layoutStatus = this.$store.state.layoutStatus;
		switch(layoutStatus) {
			case 'L0R1':
				this.OptionsRightMenu.favButtonAtion = true;
				this.$emit('getVisibleMenu', this.OptionsRightMenu);
			break;
			case 'L1R0':
			case 'L1R1':
				this.OptionsRightMenu.btnvisible = false;
				this.OptionsRightMenu.btnGroupNotesvisible = false;
				this.$emit('getVisibleMenu', this.OptionsRightMenu);
			break;
			default:
				this.OptionsRightMenu.favButtonAtion = true;
				this.$emit('getVisibleMenu', this.OptionsRightMenu);
		}
	},
  };
  </script>
  
